import React from "react"
import SubsectionContainer from "../shared/SubsectionContainer"
import Typography, { typographyTypes } from "../../shared/components/Typography"

interface AtAGlanceContentProps {
  overview: string
}

export const AtAGlanceContent: React.FC<AtAGlanceContentProps> = ({
  overview,
}) => {
  return (
    <SubsectionContainer>
      <Typography text={overview} variant={typographyTypes.NORMAL} />
    </SubsectionContainer>
  )
}
